import { render, staticRenderFns } from "./GoodsInspirationList.vue?vue&type=template&id=2c7c4307&"
import script from "./GoodsInspirationList.vue?vue&type=script&lang=js&"
export * from "./GoodsInspirationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports